import React, { FC, useCallback } from 'react';
import { ConfirmDialog } from '@beeline.com/bp-design-system';
import { useDeleteTerminationReasons } from './hooks/useDeleteTerminationReasons';
import { useTerminationReasonsIntl } from './translations/useTerminationReasonsIntl';

interface Props {
  onClose(): void;
  uid: string;
  onDone: (uid: string) => void;
}

export const TerminationReasonsDeleteModal: FC<React.PropsWithChildren<Props>> = ({ onClose, onDone, uid }) => {
  const { deleteSelected, loading } = useDeleteTerminationReasons();
  const intl = useTerminationReasonsIntl();

  const handleSubmitForm = useCallback(async () => {
    if (uid) {
      try {
        await deleteSelected(uid);
        onDone(uid);
        onClose();
      } catch {}
    }
  }, [deleteSelected, onClose, onDone, uid]);

  return (
    <ConfirmDialog
      dataTest="delete-reasons"
      loading={loading}
      onClose={onClose}
      onSubmit={handleSubmitForm}
      open
      slotProps={{
        submitButton: { children: intl.delete, error: true },
        cancelButton: { children: intl.cancel }
      }}
      title={intl.deleteConfirm}
      subTitle={intl.deleteDescription}
    />
  );
};
